module.exports = __webpack_public_path__ + "src/img/seo/twitter.b9b99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/seo/twitter.jpg
// module id = 251
// module chunks = 0